// extracted by mini-css-extract-plugin
export default {"contentBlock":"contentBlock_contentBlock__mZGoj","content":"contentBlock_content__Me5jq","actionBtn":"contentBlock_actionBtn__kZH-c"};